import IAuthRepository from "../interfaces/IAuthRepository.ts";
import { SignInInfo, SignUpInfo } from "../dto/auth";
import BaseRepository from "./BaseRepository.ts";
import { AxiosResponse } from "axios";
import { IAuthorization } from "@/repositories/dto/auth/Authorization.ts";
import ILaravelResource from "@/repositories/dto/laravel/ILaravelResource.ts";


export default class AuthRepository extends BaseRepository implements IAuthRepository {
  async signIn(data: SignInInfo): Promise<IAuthorization | void> {

    const response: AxiosResponse<ILaravelResource<IAuthorization>> | void = await this.post("/auth/signin", data);

    if (response) {
      return response.data.data;
    }
  }

  async signUp(data: SignUpInfo): Promise<IAuthorization | void> {
    const response: AxiosResponse<ILaravelResource<IAuthorization>> | void = await this.post("/auth/signup", data);
    if (response) {
      return response.data.data;
    }
  }

  async resetPassword(email: string): Promise<boolean> {
    if (email === "") {
    }
    return true;
  }

  async logout(): Promise<void> {
    await this.post("/auth/logout", {});
  }
}
